import React, { forwardRef } from "react";

const CHATBOT_BASE = "https://www.chatbase.co/chatbot-iframe/zb13EoKHT4pXMmueUNG1M";
// Public Chatbase iframe origin — required as the exact `targetOrigin`
// for the postMessage `sendMessage` contract. Exported so callers (chips)
// can post directly to the iframe's contentWindow.
export const CHATBASE_ORIGIN = "https://www.chatbase.co";

// v3.48f — Do NOT append visitor identity as URL params. Chatbase's Next.js
// iframe server returns an internal error page ("Try again" red banner) when
// the URL carries certain param combinations (UUID visitorId + empty phone,
// name containing special chars, etc.) — reproducibly breaks `/demo/dashboard`
// while `/` (root, no params) renders fine.
//
// Visitor attribution is now handled fully server-side via the
// `chatbase_identities` breadcrumb (POST /api/mira/chatbase-identity from
// Dashboard.jsx mount) + the 30-second Zoho correlation poller. The URL
// params were legacy attribution and are no longer required.
const MiraEmbed = forwardRef(function MiraEmbed({ visitor: _visitor }, ref) {
    return (
        <div className="mira-frame breath" data-testid="mira-embed-frame">
            <div className="flex items-center justify-between px-1 pb-3">
                <span className="eyebrow" style={{ color: "hsl(var(--muted))" }}>
                    Mira · AI Concierge
                </span>
                <span className="flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[hsl(var(--muted))]">
                    <span
                        aria-hidden
                        className="inline-block w-[7px] h-[7px] rounded-full"
                        style={{ background: "hsl(var(--brass))" }}
                    />
                    Online · Listening
                </span>
            </div>
            <iframe
                ref={ref}
                title="Mira — AI Concierge"
                src={CHATBOT_BASE}
                width="100%"
                style={{ height: "100%", minHeight: 660, border: 0, background: "transparent" }}
                allow="microphone"
                data-testid="mira-iframe"
            />
        </div>
    );
});

export default MiraEmbed;
